/*
 *
 * FileField constants
 *
 */

export const CLEAR = 'claris-vnext/AdvancedForm/FileField/CLEAR';
export const SHOW_ERROR_MESSAGE_FILE = 'claris-vnext/AdvancedForm/FileField/SHOW_ERROR_MESSAGE_FILE';
